import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-self-disclosure',
  templateUrl: './public-self-disclosure.component.html',
  styleUrls: ['./public-self-disclosure.component.scss']
})
export class PublicSelfDisclosureComponent implements OnInit {

  documents = [
    {
      name: "Public Self-Disclosure of Committees and Cells",
      year: "General",
      path: "/assets/pdf/public-mandatory-disclosure/Public-disclosure-bottom-1.pdf"
    },
    {
      name: "Committee Members & Constitution Details",
      year: "2025–26",
      path: "/assets/pdf/public-mandatory-disclosure/committees 25-26.pdf"
    },
    {
      name: "Committee Members & Constitution Details",
      year: "2024–25",
      path: "/assets/pdf/public-mandatory-disclosure/committees 24-25.pdf"
    },
    {
      name: "Committee Members & Constitution Details",
      year: "2023–24",
      path: "/assets/pdf/public-mandatory-disclosure/committees 23-24.pdf"
    },
    {
      name: "Committee Members & Constitution Details",
      year: "2022–23",
      path: "/assets/pdf/public-mandatory-disclosure/committees 22-23.pdf"
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}

